module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dvyEk"))).then(() => parcelRequire('hEqeo'));